import { InvoiceDetails } from 'entities/invoice/ui';
import { useInvoice } from '../../../entities/invoice/model';
import { Drawer } from 'antd';
import { useInvoiceNotifications } from '../useInvoiceNotifications';
import { useState } from 'react';
import { ReconciliationModal } from '../../../features/invoice/ReconciliationModal';

export const InvoiceDetailsSlideOver = ({ show, invoice, onClose }) => {
  const { isPending, isFetching } = useInvoice(invoice?._id);
  const {
    isPending: invoiceNotificationsPending,
    isFetching: invoiceNotificationsFetching,
  } = useInvoiceNotifications(invoice?._id, 'email');
  const [showReconciliationModal, setShowReconciliationModal] = useState(false);

  return (
    <>
      <Drawer
        closable
        destroyOnClose
        width={540}
        zIndex={10}
        title={'Invoice Details'}
        placement="right"
        open={show}
        loading={
          isPending ||
          isFetching ||
          invoiceNotificationsFetching ||
          invoiceNotificationsPending
        }
        onClose={onClose}>
        {invoice?._id && (
          <InvoiceDetails
            onReconciliationModalOpen={() => {
              setShowReconciliationModal(true);
            }}
            id={invoice._id}
            onClose={onClose}
          />
        )}
      </Drawer>

      {invoice && (
        <ReconciliationModal
          invoice={invoice}
          show={showReconciliationModal}
          onClose={() => {
            setShowReconciliationModal(false);
          }}
        />
      )}
    </>
  );
};
